module.exports = __webpack_public_path__ + "img/sweets.76010884.svg";